<script setup lang="ts">
import type { RedirectBehavior } from '@/ts/types/redirect.types'
import { LButton } from '@wgg.hyve/hyve-ui-library'
import { inject } from 'vue'
import {
  REDIRECT_BUTTON_KEY,
  type RedirectButtonSetupInjection
} from './redirect-button-setup.composable'

type RedirectButtonProps = {
  id?: string
  type?: 'reset' | 'submit' | 'button' // Workaround until the props from ui-library are public and accessible
  targetUrl: string
  targetBehavior?: RedirectBehavior
  label: string
  disabled?: boolean
}

type RedirectButtonEmits = {
  click: [targetUrl: string, targetBehavior: RedirectBehavior]
}

const { onClick } = inject<RedirectButtonSetupInjection>(REDIRECT_BUTTON_KEY) ?? {}

const props = withDefaults(defineProps<RedirectButtonProps>(), {
  type: 'button',
  targetBehavior: 'target_blank',
  disabled: false
})

const handleClick = () => {
  onClick?.(props.targetUrl, props.targetBehavior)
  emit('click', props.targetUrl, props.targetBehavior)
}

const emit = defineEmits<RedirectButtonEmits>()
</script>

<template>
  <LButton :id="id" :type="type" :label="label" :disabled="disabled" @click="handleClick()" />
</template>
